import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-NP').format(num);
}

export function formatPercentage(num: number, decimals: number = 2): string {
  return `${num.toFixed(decimals)}%`;
}

export function getPartyColor(partyCode: string): string {
  const partyColors: Record<string, string> = {
    'UML': '#DC2626',
    'NC': '#16A34A',
    'MAOIST': '#EF4444',
    'RSP': '#F59E0B',
    'RPP': '#3B82F6',
    'JSP': '#10B981',
    'LSP': '#8B5CF6',
    'IND': '#6B7280',
  };
  
  return partyColors[partyCode] || '#9CA3AF';
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  
  return function executedFunction(...args: Parameters<T>) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function convertBsToAd(yearBs: number): number {
  return yearBs - 57;
}

export function convertAdToBs(yearAd: number): number {
  return yearAd + 57;
}
